import { gql } from "@apollo/client";

const licenceFragment = gql`
    fragment licenceAdminFragment on Licence {
        id
        code
        activatedAt
        activeFrom
        activeTill
        package {
            name
        }
        camera {
            id
            cameraId
            user {
                id
                firstname
                lastname
            }
        }
    }
`;

export const purchasesListQuery = gql`
    query PurchasesListAdmin($page: Int, $sort: SortInput, $activated: Boolean, $query: String, $packageType: PackageType) {
        licencesAdmin(page: $page, sort: $sort, activated: $activated, query: $query, packageType: $packageType) {
            nodes {
                ...licenceAdminFragment
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
    ${licenceFragment}
`;

export const purchasesExportListQuery = gql`
    query PurchasesExportListAdmin($page: Int, $size: Int) {
        licenceExportAdmin(page: $page, size: $size) {
            nodes {
                ...licenceAdminFragment
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
    ${licenceFragment}
`;
